// src/device/DeviceAttribute.ts
var DeviceAttribute = class {
  constructor(device, options) {
    const { buffer, offset, stride, normalized, size, divisor, shaderLocation } = options;
    this.buffer = buffer;
    this.attribute = {
      shaderLocation,
      buffer: buffer.get(),
      offset: offset || 0,
      stride: stride || 0,
      normalized: normalized || false,
      divisor: divisor || 0
    };
    if (size) {
      this.attribute.size = size;
    }
  }
  get() {
    return this.buffer;
  }
  updateBuffer(options) {
    this.buffer.subData(options);
  }
  destroy() {
    this.buffer.destroy();
  }
};
export {
  DeviceAttribute as default
};
